import { commitMutation,
  graphql } from 'react-relay';
import environment from '../../.';
import { basicMutationOnCompleted, onErrorMutation } from '../common/common';

const mutation = graphql`
  mutation AddItemToTagMutation($tagId: ID!, $itemId: ID!, $isGlobal: Boolean) {
    addItemToTag(tagId: $tagId, itemId: $itemId, isGlobal: $isGlobal) {
      ok
      error
    }
  }
`;

export default ({
  tagId,
  itemId,
  isGlobal = false
}, done) => {
  const variables = {
    tagId,
    itemId,
    isGlobal
  };

  commitMutation(
    environment(),
    {
      mutation,
      variables,
      onCompleted: ({ addItemToTag }) => basicMutationOnCompleted(addItemToTag, done),
      onError: error => onErrorMutation(error, done)
    }
  );
};
